/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface TrainingPlanChangeUserCourseStatusBody { 
    /**
     * 
     */
    status?: TrainingPlanChangeUserCourseStatusBody.StatusEnum;
}
export namespace TrainingPlanChangeUserCourseStatusBody {
    export type StatusEnum = 'failed' | 'stopped' | 'passed' | 'passedWithConditions' | 'passedWithoutHours' | 'ongoing';
    export const StatusEnum = {
        Failed: 'failed' as StatusEnum,
        Stopped: 'stopped' as StatusEnum,
        Passed: 'passed' as StatusEnum,
        PassedWithConditions: 'passedWithConditions' as StatusEnum,
        PassedWithoutHours: 'passedWithoutHours' as StatusEnum,
        Ongoing: 'ongoing' as StatusEnum
    };
}


